export default __webpack_public_path__ + "static/impact-hero-white-2-36e23e4636d206d424d51b2089cead6a.svg";